export const  prolist = [
  {
    title: "重庆·金源时代购物中心",
    img: require("@/assets/cqjy.png"),
    desc: [
      "项目位于重庆市江北区观音桥正前方，重庆最具发展潜力的北滨路核心区金源大道路口，是世纪金源集团继成功打造观音桥地标项目金源大饭店后，在重庆的又一地标性建筑，总商业面积35万平方米。包含日用百货、大型超市、专业市场、家居卖场等多种业态。"
    ],
    url: "https://mp.weixin.qq.com/s/tvHmaBGxhL-IxdJn4_UBzw"
  },
  {
    img: require("@/assets/jn.png"),
    title: "济南IFC中央公馆",
    desc: [
      "济南IFC中央公馆位于济南市历下化纤厂路，总建筑面积16.4万㎡，共计房屋1444户。IFC中央公馆身处济南CBD，占整个CBD面积的1/4。业态分布主要为420米山东第一高楼办公、酒店、高端主题商业、新天地商业街、办公及高端住宅。项目开发分为五期。"
    ],
    url: "https://mp.weixin.qq.com/s/T-dGlrs_G0y04sW5E-wgeA"
  },
  {
    img: require("@/assets/xc.png"),
    title: "西昌唐园",
    desc: [
      "唐园坐落于四川省西昌市建昌东路，项目计划总投资7.78亿元，规划用地总面积约11万平方米，建筑总面积7万多平方米。该项目作为西昌市创建“省级公园城市”的重点文旅项目，是西昌深入挖掘历史文化、展示本地地域特色、拓展城市空间的重点体现。致力于打造成唐“潮”艺术生活街区，集文化旅游、商业为一体的综合性城市公园。"
    ],
    url: "https://mp.weixin.qq.com/s/c2BEpgaypMFExaH8lqCHmA"
  },
  {
    img: require("@/assets/gzhj.png"),
    title: "广州合景誉山国际",
    desc: [
      "合景誉山国际项目位于广州市增城区，总投资额约110亿元，建筑面积254万平方米，是集酒店、会展、购物城、写字楼、住宅于一身的3000亩大型综合体。合景誉山国际分五期开发，首期包括酒店、会展、购物、商业街、写字楼和住宅，建筑面积超过30万平方米。二期为纯别墅区，分南北两区，共有独栋、双拼等别墅。三期为洋房区。除此以外，小区周边规划有医院、国际学校、运动场馆、文化活动中心幼儿园、小学、中学等。"
    ],
    url: "https://mp.weixin.qq.com/s/aK6TEqwqus8B9y1-xVF1sA"
  },
  {
    img: require("@/assets/xa.png"),
    title: "西安富平新里城",
    desc: [
      "西安富平绿地新里城，位于西安市荆山大道与怀德大街交汇处。项目隶属于绿地集团新里系的高端产品系，它缘起新式里弄，中西合璧，充分结合了“传统，品质，人文，智慧”四大特质，打造高端人文社区，主要针对城市菁英。项目总占地228亩，总规划33万方、42栋楼，容积率低至1.8，分两个地块开发。产品含住宅、商业5300㎡及教育配套设施。"
    ],
    url: "https://mp.weixin.qq.com/s/MB0T00p7xizsLop5I_FnxA"
  },
  {
    img: require("@/assets/zd.png"),
    title: "中电建云立方",
    desc: [
      "云立方项目地处成都市龙泉驿区龙城大道816号，项目总占地128亩，项目住宅部分建筑面积38.2万平米，并配套4.1万平米建面商业，项目内还规划有幼儿园。"
    ],
    url: "https://mp.weixin.qq.com/s/QfYSSSAksVhnLmOBibBHeQ"
  },
  {
    img: require("@/assets/gzyh.png"),
    title: "广州永荟广场",
    desc: [
      "永荟广场项目位于广州东TOD国际交通枢纽附近（香山大道与创新大道交汇处），占地面积约21万㎡，总建面约75万㎡大型商业综合体。项目落成后将成为新塘开发区的商业核心圈，项目本身自带建面约23万㎡永旺梦乐城华南旗舰店，加上项目旁的新塘万达广场等商业，将为区域带来百万消费人群。"
    ],
    url: "https://mp.weixin.qq.com/s/2DkY2nsVtulyPSBoiqV9LA"
  }
]



// WEBPACK FOOTER //
// ./src/untils/pro.js